
import { Carousel } from 'bootstrap';
import EmblaCarousel, { EmblaOptionsType } from 'embla-carousel'
import { addDotBtnsAndClickHandlers } from '../modules/EmblaCarouselDotButton'


const initHome = () => {
    const myCarouselElement = document.querySelector('#homepageStepsCarousel')
    if (!myCarouselElement) return
    const carousel = new Carousel(myCarouselElement, {
        interval: 2000,
        wrap: false
    })

    document.querySelectorAll(".step-link").forEach((element) => {
        element.addEventListener("click", (event) => {
            event.preventDefault();
            var target = event.currentTarget as HTMLAnchorElement;
            if (!target.dataset.index) return console.log("No index found");
            carousel.to(parseInt(target.dataset.index));
            var oldActive = document.querySelector(".home-steps .list-group-item.active")
            if (oldActive) oldActive.classList.remove("active");

            target.parentElement?.classList.add("active");

            return false;
        })
    });


    myCarouselElement.addEventListener('slide.bs.carousel', event => {

        var oldActive = document.querySelector(".home-steps .list-group-item.active")
        if (oldActive) oldActive.classList.remove("active");

        var newActive = document.querySelector(".home-steps .list-group-item:nth-child(" + (event.to + 1) + ")")?.classList.add("active");
    })

    function initHomepageBrandsSlider() {
        const OPTIONS : EmblaOptionsType = { dragFree: true, loop: true, slidesToScroll: 'auto' }

        const emblaNode = <HTMLElement>document.querySelector('.homepage-brands-embla')
        const viewportNode = <HTMLElement>emblaNode.querySelector('.embla__viewport')
        const dotsNode = <HTMLElement>emblaNode.querySelector('.embla__dots')


        const emblaApi = EmblaCarousel(viewportNode, OPTIONS, [])
        const removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(
            emblaApi,
            dotsNode
        )
        emblaApi.on('destroy', removeDotBtnsAndClickHandlers)


        console.log(emblaApi);

    }

    initHomepageBrandsSlider();

};

export default initHome;